"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseEvent_1 = tslib_1.__importDefault(require("../../../../src/common/BaseEvent"));
const enums_1 = require("../../../../types/enums");
class OpenForBusinessEvent extends BaseEvent_1.default {
    constructor(status, address) {
        super();
        this.status = status;
        this.address = address;
    }
    sendEvent() {
        this.sendSegmentEvent(enums_1.SaasAnalyticsEvents.OPEN_FOR_BUSINESS, {
            status: this.status,
            address: this.address,
        });
    }
}
exports.default = OpenForBusinessEvent;
//# sourceMappingURL=index.js.map